export default "__VITE_ASSET__DvhAgfvw__"